<div class="modify-efficiency-treshold">
  <div class="content">
    <div class="container">
      <app-d3-line-gauge-chart [efficiencyTreshold]="" [data]="data"></app-d3-line-gauge-chart>
    </div>
    <div>
      <table class="table" aria-describedby="efficiency-analysis">
        <tr>
          <th scope="col" class="header label1">Typ</th>
          <th scope="col" class="header label2">gut / mittel</th>
          <th scope="col" class="header label3">mittel / schlecht</th>
        </tr>
        <tr>
          <td class="input-label">Grenzwert</td>
          <td>
            <div class="input-group">
              <input class="input" [formControl]="efficientTresholdControl" placeholder="0" maxlength="2" (keypress)="numberOnly($event)" />
              <label class="unit label">%</label>
            </div>
          </td>
          <td>
            <div class="input-group">
              <input class="input" [formControl]="inefficientTresholdControl" placeholder="0" maxlength="2" (keypress)="numberOnly($event)" />
              <label class="unit label">%</label>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
  <div class="btn-container">
    <div class="buttons">
      <button class="btn btn-outline-secondary" (click)="cancel()">
        {{ 'module.efficiencyAnalysis.efficiencyAnalysisConfigDialog.cancel' | translate }}
      </button>
      <button class="btn btn-outline-primary" (click)="save()" [disabled]="checkButtonStatus()">
        {{ 'module.efficiencyAnalysis.efficiencyAnalysisConfigDialog.save' | translate }}
      </button>
    </div>
  </div>
</div>
